import { createContext } from 'react';

export const CompanyContext = createContext(null);

export function CompanyProvider({ value, children }) {
    return (
        <CompanyContext.Provider value={value}>
            {children}
        </CompanyContext.Provider>
    );
}
